import type { RepoNamespace } from '~/components/header/GithubCreateRepoFlow';
import { Avatar } from '~/components/ui/Avatar';
import { Button } from '~/components/ui/Button';
import { Dialog, DialogDescription, DialogTitle } from '~/components/ui/LegacyDialog';
import { userData } from '~/lib/client-github';

export function GithubConnectedDialog({
  open,
  repo,
  onClose,
}: {
  onClose: () => void;
  open: boolean;
  repo: RepoNamespace;
}) {
  return (
    <Dialog onClose={onClose} open={open} maxWidth={600}>
      <DialogTitle className="p-6 font-bold text-lg border-b-1px border-bolt-elements-borderColor">
        <span className="flex items-center gap-1 text-lg">
          <span className="i-bolt:logos-github?mask text-2xl"></span>
          <span className="font-semibold">Connected to GitHub</span>
        </span>
      </DialogTitle>
      <DialogDescription>
        <div className="pb-6 flex flex-col items-center w-full">
          <div className="w-full">
            <div className="text-sm mb-2">Linked project</div>
            <a
              href={`https://github.com/${repo.owner}/${repo.name}`}
              target="_blank"
              className="text-inherit! no-underline! border-1px border-bolt-elements-borderColor rounded flex items-center py-3 px-4 justify-between"
            >
              <div className="flex items-center">
                <Avatar user={userData({ name: repo.owner, avatar: repo.avatarUrl }, repo.owner)} className="mr-4" />
                <div>
                  {repo.owner}&emsp;/&emsp;{repo.name}
                </div>
              </div>

              <div>see on GitHub</div>
            </a>
          </div>
          <div className="mt-4 flex text-sm text-bolt-elements-textSecondary mb-6 text-left border-bolt-elements-borderColor border-1px p-3 rounded-md w-100%">
            <div>
              <div className="p-10px mr-2 i-ph:info dark:text-white light:text-black"></div>
            </div>
            <div>
              <p className="text-bolt-elements-textSecondary">
                Changes you make in Bolt will be automatically committed to GitHub. Similarly, any changes pushed to the
                GitHub repository will be reflected in your Bolt project, enabling seamless backups and edits.
              </p>
            </div>
          </div>

          <div className="flex justify-end w-full">
            <Button variant="primary" onClick={onClose}>
              Start building
            </Button>
          </div>
        </div>
      </DialogDescription>
    </Dialog>
  );
}
